/**
 * Class used to handle the bubbles animation.
 *
 * @since 0.1.0
 * @class Bubbles
 */
class Bubbles {
    /**
     * Creates an instance of Bubbles.
     * 
     * @since 0.1.0
     * @memberof Bubbles
     */
    constructor() {
        this.bubblyButtons = document.querySelectorAll( '.ts-bubbly' );
        this.events = this.events.bind( this );
        this.animate = this.animate.bind( this );

        this.events();
    }

    /**
     * Listens for events.
     *
     * @since 0.1.0
     * @listens event:click
     * @memberof Bubbles
     */
    events() {
        !!this.bubblyButtons.length && this.bubblyButtons.forEach( elem => {
            elem.addEventListener( 'click', this.animate );
        } );
    }

    /**
     * Animates the element.
     *
     * @since 0.1.0
     * @param object e
     * @memberof Bubbles
     */
    animate( e ) {
        e.preventDefault();
        e.target.classList.remove( 'ts-bubbly-animate' );
        e.target.classList.add( 'ts-bubbly-animate' );

        setTimeout( () => {
            e.target.classList.remove( 'ts-bubbly-animate' );
            window.location = e.target.getAttribute( 'href' );
        }, 700 );
    }
}

export default Bubbles;
